import { useState } from 'react';

import { getLocationMobile } from './use-get-native-info';
import { isWebContext } from '../utils/is-web-context';

type HandleGeoType = {
  onSuccess?: (position: GeolocationPosition) => void;
  onError?: (err: GeolocationPositionError) => void;
  onNavigatorError?: () => void;
};
export const useGeo = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGetLocationNative = ({ onSuccess, onError }: HandleGeoType) => {
    setIsLoading(true);

    const handleSuccess = (position: GeolocationPosition) => {
      setIsLoading(false);
      onSuccess?.(position);
    };
    const handleError = (err: string) => {
      setIsLoading(false);

      const errConverted: { [key in string]: number } = {
        ERROR: 2,
        CANCELED: 1,
      };

      // todo resume with web check

      onError?.({
        code: errConverted[err],
        message: err,
        PERMISSION_DENIED: 1,
        TIMEOUT: 3,
        POSITION_UNAVAILABLE: 2,
      });
    };

    getLocationMobile({ onSuccess: handleSuccess, onError: handleError });
  };

  const handleGetLocationWeb = ({ onSuccess, onError, onNavigatorError }: HandleGeoType) => {
    if (navigator.geolocation) {
      setIsLoading(true);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setIsLoading(false);
          onSuccess?.(position);
        },
        (err: GeolocationPositionError) => {
          setIsLoading(false);

          onError?.(err);
        },
        { timeout: 10000 },
      );
    } else {
      onNavigatorError?.();
    }
  };

  const handleGetLocation = ({ onSuccess, onError, onNavigatorError }: HandleGeoType) => {
    if (isWebContext) {
      return handleGetLocationWeb({ onSuccess, onError, onNavigatorError });
    }

    return handleGetLocationNative({ onSuccess, onError });
  };

  return {
    isLoading,
    handleGetLocation,
  };
};
